<template>
    <div style="display:contents">
        <draggable
            v-model="sortedGroups"
            style="display:contents"
            draggable=".CostableTableGroupDraggable"
            handle=".CostableTableGroupHeadingHandle"
        >

            <CostableTableGroup
                v-for="group in groups"
                :key="group.id"
                :group="group"
            />

        </draggable>

        <CostableTableAddCost v-if="!groups.length" />

    </div>
</template>

<script>
import draggable from 'vuedraggable';
import CostableTableGroup from './CostableTableGroup';
import CostableTableAddCost from './CostableTableAddCost';

export default {

    components: {
        draggable,
        CostableTableGroup,
        CostableTableAddCost,
    },

    props: {
        groups: {
            type: Array,
            required: true,
        },
    },

    computed: {
        sortedGroups: {
            get() {
                return this.groups;
            },
            set(groups) {
                this.$store.dispatch('costable/updateGroupsOrder', groups);
            },
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
